import './landing.css';
import BoxLanding from './box-landing';
import contentData from './ContentBanner';
import { useContext } from 'react';
import AppContext from '../../AppContext';

function BannerLanding({ landingPage }) {
    const appcontext = useContext(AppContext);
    const hasbundles2026=(appcontext && appcontext.features && (appcontext.features.bundle2026));
    const landingPageDef=(landingPage=='edu' && hasbundles2026?'edu2026':landingPage);
    const content = contentData[landingPageDef] || contentData.default;

    return (
        <section className='banner-landing' style={{ backgroundImage: content.backgroundImage }}>
            <div className='banner-overlay'></div>
            <div className='banner-content'>
                <div className='banner-headings'> 
                    <h1 dangerouslySetInnerHTML={{ __html: content.mainTitle }}></h1>
                    <h2 dangerouslySetInnerHTML={{ __html: content.subTitle }}></h2>
                </div>
                <BoxLanding landingPage={landingPageDef} />
            </div>
        </section>
    );
}

export default BannerLanding;
